import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.83484 11.4017C8.43959 12.0007 7.56073 12.0007 7.16549 11.4017L4.40458 7.21743C3.96589 6.55257 4.44271 5.66669 5.23926 5.66669L10.7611 5.66669C11.5576 5.66669 12.0344 6.55257 11.5957 7.21743L8.83484 11.4017Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
